const capitalizeFirstLetter = (name: string) => {
  name = name.trim()

  if (name[0].match(/"/)) {
    name = name[0] + name[1].toUpperCase() + name.substring(2).toLowerCase()
  } else {
    name = name[0].toUpperCase() + name.substring(1).toLowerCase()
  }

  return name
}

export default capitalizeFirstLetter
